/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import defaultPropTypes from '../utils/prop-types';
var LocationDetail = function LocationDetail(props) {
  var location = props.locations.find(function (loc) {
    return loc.UniqueId.toString() === props.match.params.id.toString();
  });
  var phoneClickHandler = function phoneClickHandler() {
    window.location.href = "tel:".concat(location.Phone);
    window.DGS.Event.getInstance().trigger('trackLocationsPhoneNumber', location.Name, location.PostalCode);
  };
  var websiteClickHandler = function websiteClickHandler() {
    window.open(location.Homepage);
    window.DGS.Event.getInstance().trigger('trackLocationsWebsiteLink', location.Name, location.PostalCode);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "location-detail"
  }, location && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, location.Name)), /*#__PURE__*/React.createElement("button", {
    className: "close-button",
    onClick: function onClick(e) {
      props.onCloseLocation(e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("strong", null, location.Name)), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-left-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, location.Address), /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, location.PostalCode, " ", location.City), /*#__PURE__*/React.createElement("div", {
    className: "distance"
  }, /*#__PURE__*/React.createElement("i", null, "".concat(props.distance, " ").concat(props.settings.Unit, " ").concat(props.settings.dictionary.fromYourLocation)))), /*#__PURE__*/React.createElement("div", {
    className: "info-right-col"
  }, !!location.Phone && /*#__PURE__*/React.createElement("div", {
    className: "phone"
  }, "".concat(props.settings.dictionary.phone, ": "), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: phoneClickHandler,
    title: location.Phone
  }, location.Phone)), !!location.Homepage && /*#__PURE__*/React.createElement("div", {
    className: "website"
  }, "".concat(props.settings.dictionary.website, ": "), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: websiteClickHandler,
    title: location.Homepage
  }, location.Homepage))))));
};
LocationDetail.propTypes = {
  onCloseLocation: defaultPropTypes.func,
  settings: defaultPropTypes.settings.isRequired,
  locations: defaultPropTypes.locations.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
  distance: PropTypes.string.isRequired
};
LocationDetail.defaultProps = {
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation
};
export default withRouter(LocationDetail);